import React, { useContext } from 'react'
import { OffreModel } from '../types/OffreModel'
import { FormattedMessage } from 'react-intl'
import TronquageTexte from '../../../components/formatteurTexte/TronquageTexte'
import { ResponsiveContext } from '../../../utils/context/ResponsiveContext'
import styles from '../../../styles'
import { makeStyles } from 'tss-react/mui'
import { Grid } from '@mui/material'

const useStyles = makeStyles<{ isLargeScreen: boolean }>()(
	(theme, { isLargeScreen }) => ({
		descriptionContainer: {
			marginBottom: isLargeScreen ? 91 : 74
		},
		titre: {
			...styles(theme).title0,
			fontSize: isLargeScreen ? 35 : 22,
			marginBottom: isLargeScreen ? 35 : 39,
			marginTop: 0
		},
		texte: {
			...styles(theme).text1,
			margin: 0,
			whiteSpace: 'break-spaces'
		}
	})
)

interface AcceptingProps {
	offre: OffreModel
}

type DescriptionProps = AcceptingProps

const Description: React.FC<DescriptionProps> = (
	{
		offre
	}
) => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const { classes } = useStyles({ isLargeScreen })
	const caracteresATronquer = 400

	return (
		<Grid container item xs={12} className={classes.descriptionContainer}>
			<Grid item xs={12}>
				<h2 className={classes.titre}>
					<FormattedMessage
						id={`offre.description.titre.${offre.type}`}
						defaultMessage="Description de l'appartement à louer"
						description="Titre de la description"
					/>
				</h2>
			</Grid>

			<Grid item xs={12}>
				<TronquageTexte
					texte={offre.description}
					texteStyle={classes.texte}
					caracteresATronquer={caracteresATronquer}
				/>
			</Grid>
		</Grid>
	)
}

export default Description